import React from "react";
import ReactDOM from "react-dom";
import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import App from "./js/App";
import PreviewApp from "./js/containers/PreviewApp";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <DragDropContextProvider backend={HTML5Backend}>
    {/* 預覽模式（教務出題後試做）：完全不經過 App——正式作答的流程、計時、存檔一概不碰 */}
    {window.location.pathname.startsWith("/preview-") ? <PreviewApp /> : <App />}
  </DragDropContextProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
